var render, staticRenderFns
import script from "./Box.vue?vue&type=script&lang=js&"
export * from "./Box.vue?vue&type=script&lang=js&"
import style0 from "./Box.vue?vue&type=style&index=0&id=ebc4c05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc4c05e",
  null
  
)

/* custom blocks */
import block0 from "./Box.vue?vue&type=custom&index=0&blockType=meta"
if (typeof block0 === 'function') block0(component)
import block1 from "./Box.vue?vue&type=custom&index=1&blockType=example"
if (typeof block1 === 'function') block1(component)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Box', component.exports)
}
export default component.exports